import swal from 'sweetalert'
import lodash from 'lodash'
import ChildComment from './child-comment'
import { mapGetters } from 'vuex'
import EditComment from './edit-comment'

export default {
  name: 'comment',
  components: {ChildComment, EditComment},
  props: ['checklist_item', 'comments'],
  data () {
    return {
      open_upload_image: false,
      open_upload_file: false,
      cmt: {
        content: '',
        issue: '',
        result: '',
        attach: []
      },
      errors: {},
      files: [],
      preview: [],
      btn_submit: false,
      issue:false,
      child_comment:false
    }
  },
  computed: {
    ...mapGetters({
      profile: 'Profile/getProfile'
    }),
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    }
  },
  mounted () {

  },
  methods: {
    openUploadImage () {
      this.open_upload_image = !this.open_upload_image
      this.open_upload_file = false;
    },
    addissue(){
      this.issue = !this.issue
    },

    // Attrack file
    openUploadFile(){
      this.open_upload_file = !this.open_upload_file
      this.open_upload_image =false
    },

    //comment
    comment () {
      // console.log(this.cmt.attach.length)s
      this.btn_submit = true
      const data = new FormData()
      let content = this.cmt.result
      if(this.issue && (this.cmt.issue !='' || this.cmt.result !='')){
        content = this.$t('comment.issue')+": "+this.cmt.issue+"<br/>"+this.$t('comment.result')+": "+this.cmt.result;
      }
      let attach =this.cmt.attach.length>0?"<br/>"+this.cmt.attach: '';

      data.append('content', content+attach)
      data.append('parent_id', 0)
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        data.append('images[' + i + ']', file)
      }
      this.$loading.start()
      this.$store.dispatch('Comment/createCommentOfChecklistItem', {checklist: {id: this.$route.params.checklist_id}, checklist_item: this.checklist_item, comment: data}).then(res => {
        res.children = []
        this.comments.push(res)
        this.cmt = {
          content: '',
          issue: '',
          result: '',
          attach: []
        }
        this.files = []
        this.preview = []
        this.errors = {}
        this.$loading.complete()
        this.issue = false,
        this.checklist_item.no_cmt += 1
        this.btn_submit = false
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
        this.$loading.fail()
      })
    },

    //event upload image
    change (event) {
      this.open_upload_image = false
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.files.push(this.$refs.files.files[i])
        let reader = new FileReader()
        reader.onload = (event) => {
          this.preview.push(event.target.result)
        }
        reader.readAsDataURL(this.$refs.files.files[i])
      }
    },

    //event upload file
    uploadFile(event){
      const fd = new FormData()
      fd.append('file', this.$refs.files.files[0])
      fd.append('type', 'file')
      this.$store.dispatch('Comment/attachFileInComment',{file: fd}).then(res => {
        this.cmt.attach.push('<a target="_blank" href=https://docs.google.com/viewerng/viewer?url='+res+'>'+this.$refs.files.files[0].name+'</a>')
        this.open_upload_file = !this.open_upload_file
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
          this.open_upload_file = !this.open_upload_file

        }
        this.$loading.fail()
      })
    },

    //remove file attach 
    removeFile(index){
      this.cmt.attach.splice(index, 1)
    },

    //remove preview image
    remove (index) {
      this.files.splice(index, 1)
      this.preview.splice(index, 1)
      delete this.errors['images.'+index]
    },
    destroy (comment) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('Comment/destroyCommentOfChecklistItem', {
              checklist: {id: this.$route.params.checklist_id}, checklist_item: this.checklist_item, comment
            }).then((res) => {
              var index = lodash.findIndex(this.comments, ['id', comment.id])
              this.comments.splice(index, 1)
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.checklist_item.no_cmt -= 1
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    },
    closeComment () {
      this.$store.commit('Audit/closeCommentOfChecklistItem', this.checklist_item)
    },
    // openReply (comment) {
    //   comment.open_reply = comment.open_reply ? !comment.open_reply : true
    //   var index = lodash.findIndex(this.comments, ['id', comment.id])
    //   this.comments.splice(index, 1, comment)
    //   this.checklist_item.comments = this.comments
    //   this.$store.commit('Audit/addCommentToChecklistItem', this.checklist_item)
    // },
    update (comment) {
      this.$refs.edit_comment.showModel(this.checklist_item, comment)
    },
    setFinal (comment) {
      if (comment.is_final) {
        return false
      }
      this.$loading.start()
      this.$store.dispatch('Comment/setCommentIsFinal', {comment}).then(res => {
        this.$loading.complete()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.comments.forEach(element => {
          element.is_final = false
        })
        comment.is_final = true
        var index = lodash.findIndex(this.comments, ['id', comment.id])
        this.comments.splice(index, 1, comment)
        this.checklist_item.comments = this.comments
        this.$store.commit('Audit/addCommentToChecklistItem', this.checklist_item)
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    updateSuccess (comment) {
      var index = lodash.findIndex(this.comments, ['id', comment.id])
      comment.children = this.comments[index].children
      this.comments.splice(index, 1, comment)
      this.checklist_item.comments = this.comments
      this.$store.commit('Audit/addCommentToChecklistItem', this.checklist_item)
    },

    checkcomment () {
      if (parseInt(this.checklist_item.checklist_item_status.is_cmt)) {
        return true
      } else {
        return false
      }
    },

    handleBlur () {
      this.$loading.start()
      this.$store.dispatch('Audit/setCorrectiveDate', {checklist: {id: this.$route.params.checklist_id}, checklist_item: this.checklist_item}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    changeCorrectiveStatus () {
      this.$loading.start()
      this.$store.dispatch('Audit/setCorrectiveStatus', {checklist: {id: this.$route.params.checklist_id}, checklist_item: this.checklist_item}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    //show reply comment
    showReply(index){
      this.child_comment = index
      console.log(this.child_comment)
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/checklist-item/comment/comment.js